import { Modal } from "@/components/renderbus-modal";
import { ModalProps, FormInstance } from "antd";
import { Form, Input, Button } from "@renderbus/ui";
import { useGlobalStore } from "@/store/GlobalStore";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { IAccessKeyInfo } from "../types";
import { getHideEmail, getHidePhone } from "project-config/utils/str-helper";
import styled, { createGlobalStyle } from "styled-components";
import { isEn } from "project-config/utils/env";
import { useSendCode } from "@/hooks/useSendCode";
import { useVerifySendCode } from "./hooks/useVerifySendCode";

export function VerifyModal({
  open,
  modalProps,
  form,
  accessKeyInfo,
}: {
  open: boolean;
  modalProps: ModalProps;
  form: FormInstance;
  accessKeyInfo?: IAccessKeyInfo;
}) {
  const { isDomestic, userInfo } = useGlobalStore();
  const t = getTranslateNsT("center");
  const { sendCode, sending, sendCodeDisable, countdown } = useSendCode(
    isDomestic,
    60
  );
  const { handleSendCode } = useVerifySendCode(isDomestic, userInfo);

  return (
    <>
      <Modal
        open={open}
        {...modalProps}
        className={"renderbus-ui--modal developer-verify-modal"}
        children={
          <Form
            form={form}
            labelCol={{ span: isEn() ? 7 : 4 }}
            labelAlign="right"
          >
            <Form.Item
              name={isDomestic ? "phone" : "email"}
              label={isDomestic ? t("user_bind_phone") : t("user_bind_email")}
              initialValue={
                isDomestic
                  ? getHidePhone(accessKeyInfo?.phone)
                  : getHideEmail(accessKeyInfo?.email)
              }
            >
              <Input disabled />
            </Form.Item>
            <Form.Item
              name="verificationCode"
              label={t("user_verification_code")}
              rules={[
                { required: true, message: t("user_verification_code_error") },
              ]}
            >
              <Row>
                <Input />
                <Button
                  ghost
                  size="middle"
                  onClick={() => handleSendCode(sendCode)}
                  disabled={sendCodeDisable}
                  loading={sending}
                >
                  {countdown ? `${countdown}s` : t("user_click_get")}
                </Button>
              </Row>
            </Form.Item>
          </Form>
        }
      />
      <DeveloperModalStyle />
    </>
  );
}

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DeveloperModalStyle = createGlobalStyle`
  .developer-verify-modal {
    input {
      background: #2C2C31 !important;
    }
  }
`;
